module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "01automatic.5a842d2c.png" + "?" + Date.now();